export const createCell = (text) => {
  return {
    'paragraphs': [ // -必填
      {
        'contents': [ // -必填
          {
            'tagType': 'text', // 内容标签，支持文本标签：text， 图片标签：image
            // -必填，后端需要根据该值路由不同的标签处理
            text
            // 'text': '' // 普通文本内容
            // 'style': {}, // 文本样式，具体可参考文本标签json
            // 'linkText': '', // 链接地址显示文本
            // 'linkUrl': '' // 链接地址url
          }
          // {
          //   'tagType': 'image', // 内容标签，支持文本标签：text， 图片标签：image
          //   // -必填，后端需要根据该值路由不同的标签处理
          //   'imageType': 'JPG', // 图片类型
          //   'imageUrl': 'http://image.jpg', // 图片链接地址，本地图片地址或网络文件地址
          //   'width': 20, // 图片宽度，像素单位
          //   'height': 20, // 图片高度，像素单位
          //   'align': 'center' // 对齐方式，center:居中对齐，left：左对齐，right：右对齐
          // }
        ]
        // 'paragraphStyle': {
        //   'align': '',
        //   'indentFirstLineChars': 20.0, // 首行缩进
        //   'space': 10.0, // 段落间距
        //   'backgroundColor': '' // 段落背景色
        // }
      }
    ],
    'cellStyle': {
      // 'backgroundColor': '00FF00', // 单元格背景色
      'vertAlign': 'center' // 垂直对齐方式，固定值：center，可不填
    }
  }
}
// 由于需要从对象获取key，再组成单元格列表，所以先通过表格定义的顺序获取key的顺序，确保单元格排序与表格定义的一致
export const getSortTableKey = (columnDefs) => {
  return columnDefs.map(item => {
    return item.prop
  })
}
